import { PaymentSummaryScreen } from '@/modules/payments';
import { Platform } from 'react-native';

export default function PaymentSummaryRoute() {
    return <PaymentSummaryScreen useCloseIcon={Platform.OS === 'web'} />;
}
